import { Component } from '@angular/core';

@Component({
    selector: 'app',
    template: `<navbar></navbar>
    <div id="lightbox-app">
    <router-outlet></router-outlet>
    </div>
    <tour-step-template></tour-step-template>
    <footer></footer>`
})
export class AppComponent {}
